import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

import { TrendContainer } from "../../../../../app/components/React/Table/cells/TrendCell";
import { DefaultCellHeaderRightAlign } from "../../../../../app/components/React/Table/headerCells";
import { LeadGeneratorChangePercentageRightAlign } from "../../../../../app/pages/lead-generator/lead-generator-exist/components/StyledComponents";
import { FlexColumn, FlexRow } from "../../../../styled components/StyledFlex/src/StyledFlex";
import { StyledBox } from "../../../../styled components/Workspace/src/StyledWorkspaceBox";

const ListCardWrapper = styled(StyledBox)`
    display: flex;
    flex-direction: column;
    height: 298px;
    width: 368px;
    margin: 0 16px 16px 0;
    transition: background-color 200ms ease-in-out;
    cursor: pointer;
    &:hover {
        box-shadow: 0 3px 6px ${rgba(colorsPalettes.midnight[600], 0.2)};
    }
`;

export const ListCardHeaderContainer = styled.div`
    margin: 16px 16px 8px;
`;

export const ListCardTableContainer = styled.div`
    height: 184px;
    .MiniFlexTable {
        padding-bottom: 0;
    }
    && {
        .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-headerCell,
        .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-cell {
            display: flex;
            align-items: center;
            padding: 0 0 0 12px;
            box-sizing: border-box;
        }
    }
    .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-cell {
        height: 48px;
        font-size: 14px;
        line-height: 16px;
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
    .MiniFlexTable-container .MiniFlexTable-column .MiniFlexTable-headerCell {
        height: 32px;
        color: ${rgba(colorsPalettes.carbon[500], 0.6)};
        font-weight: 500;
        border-top: 1px solid ${colorsPalettes.carbon["50"]};
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
    ${TrendContainer} {
        width: 100%;
    }
    .changePercentage,
    ${LeadGeneratorChangePercentageRightAlign}, ${DefaultCellHeaderRightAlign} {
        width: 100%;
        padding-right: 12px;
    }
`;

export const OverviewSectionTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
    margin-bottom: 8px;
`;

export const ListCardTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${colorsPalettes.carbon[500]};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
`;

export const ListCardSubtitle = styled(FlexRow)`
    font-size: 12px;
    color: ${rgba(colorsPalettes.carbon[500], 0.6)};
`;

export const OverviewNewListCard = styled(ListCardWrapper)`
    background-color: ${rgba(colorsPalettes.bluegrey[300], 0.25)};
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in-out;
    box-shadow: none;
    &:hover {
        background-color: ${rgba(colorsPalettes.bluegrey[300], 0.4)};
        cursor: pointer;
        box-shadow: none;
    }
`;

export const ListCardCountryIcon = styled.div`
    height: 12px;
    width: 12px;
    margin: 2px 4px 0 2px;
`;

export const ListCardBullet = styled.div.attrs(
    (props) =>
        ({
            children: <span>•</span>,
        }) as any,
)`
    margin: 0 2px;
`;

export const CardListEmptyContainer = styled(FlexColumn)`
    align-items: center;
    width: 168px;
    img {
        width: 64px;
        height: 80px;
    }
    button {
        margin-top: 8px;
    }
`;
